import { render, staticRenderFns } from "./MreglaGrid.vue?vue&type=template&id=0a0e16a2"
import script from "./MreglaGrid.vue?vue&type=script&lang=js"
export * from "./MreglaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports